






import { Vue, Component, Prop } from 'vue-property-decorator';
import { getValidateCode } from 'service/api';

@Component
export default class TimerButton extends Vue {
  @Prop(String) readonly phone!: string;

  @Prop(String) readonly codeType!: string;

  showTime = '';

  counter: NodeJS.Timeout | null = null;

  get isClickable() {
    return (this.phone && this.phone.match(/^1[3456789]\d{9}$/) && !this.counter);
  }

  getCode() {
    if (!this.isClickable) return;
    getValidateCode({
      phonenumber: this.phone,
      type: this.codeType,
    }).then((res) => {
      if ((res as { code: number; message: string }).code === 200) {
        this.timer();
        this.$message.success('验证码已发送');
      } else {
        this.$notify.error((res as { code: number; message: string }).message || '发送失败');
      }
    });
  }

  timer() {
    let count = 60;
    this.showTime = `${count}s`;
    this.counter = setInterval(() => {
      count -= 1;
      if (count === 0) {
        if (this.counter) {
          clearInterval(this.counter);
        }
        this.counter = null;
        this.showTime = '';
        return;
      }
      this.showTime = `${count}s`;
    }, 1000);
  }
}
